import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import './styles.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import api from '../../services/api';

function CreateMov(){
    const [description, setDescription] = useState('');
    const [value, setValue] = useState(0.0);
    const [type, setType] = useState('');
    const [date, setDate] = useState(Date);

    const history = useHistory();

    async function HandleSubmit(e){
        e.preventDefault();

        const data = {
            description,
            value,
            type,
            date
        };

        try {
            const response = await api.post('fluxo', data);
            alert('Movimentação criada com Sucesso!');
            history.push('/fluxo-de-caixa');
        } catch (error) {
            alert(error);
        }
    }

    return(
        <>
            <Header/>

            <div id="content">
                <form onSubmit={HandleSubmit}>
                    <h1>Crie uma Movimentação</h1>

                    <input
                        type='text'
                        placeholder = 'Descrição da Movimentação'
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                    <input
                        type='number'
                        placeholder = 'Valor'
                        value={value}
                        onChange={e => setValue(e.target.value)}
                    />
                    <input 
                        type='text'
                        placeholder='Tipo: Entrada (E) ou Saída (S)'
                        value={type}
                        onChange={e => setType(e.target.value)}
                    />
                    <input 
                        type='date'
                        placeholder='Data da Movimentação'
                        value={date}
                        onChange={e => setDate(e.target.value)}
                    />
                    <button type='submit'>Criar</button>
                </form>
            </div>

            <Footer/>
        </>
    );
}

export default CreateMov;